import "../App.css";
import { Link } from "react-router-dom";

function Summary() {
  return (
    <div>
      <div id="container">
        <div class="">
          <div class="">
            <div class="tailwind css-myl2ny css-exq74d css-gs60ek">
              <div class="min-h-screen transition-colors duration-200 bg-gray-50 text-gray-900">
                <div class="border-b sticky top-0 z-40 backdrop-blur-sm bg-white/95 border-gray-200">
                  <div class="max-w-7xl mx-auto px-6 py-4">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center gap-4">
                        <button
                          data-slot="button"
                          class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-8 rounded-md px-3 has-[&gt;svg]:px-2.5 flex items-center gap-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-arrow-left w-4 h-4"
                            aria-hidden="true"
                          >
                            <path d="m12 19-7-7 7-7"></path>
                            <path d="M19 12H5"></path>
                          </svg>
                          <Link to="/">Back to Summary</Link>
                        </button>
                        <div
                          data-orientation="vertical"
                          role="none"
                          data-slot="separator-root"
                          class="bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px h-8"
                        ></div>
                        <div class="flex items-center gap-3">
                          <img
                            src="/sai-logo.avif"
                            alt="SAI Agent"
                            class="w-8 h-8"
                          />
                          <div>
                            <h1 class="font-semibold text-lg text-gray-900">
                              Legal Analysis
                            </h1>
                            <p class="text-xs text-gray-500">
                              Kaseya - Due Diligence Report
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="flex items-center gap-3">
                        <button
                          data-slot="button"
                          class="justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-8 rounded-md px-3 has-[&gt;svg]:px-2.5 flex items-center gap-2"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-download w-4 h-4"
                            aria-hidden="true"
                          >
                            <path d="M12 15V3"></path>
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <path d="m7 10 5 5 5-5"></path>
                          </svg>
                          Export Report
                        </button>
                        <button
                          data-slot="button"
                          class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 h-8 rounded-md gap-1.5 px-3 has-[&gt;svg]:px-2.5"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-moon w-4 h-4"
                            aria-hidden="true"
                          >
                            <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"></path>
                          </svg>
                        </button>
                        <div class="flex items-center gap-2">
                          <div class="avatar-circle" data-initials="GC"></div>
                          <span class="text-sm font-medium text-gray-900">
                            Gordon Caplan
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="max-w-7xl mx-auto px-6 py-8">
                  <div class="mb-8">
                    <div class="flex items-center gap-3 mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-scale w-8 h-8 text-sai-blue"
                        aria-hidden="true"
                      >
                        <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                        <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"></path>
                        <path d="M7 21h10"></path>
                        <path d="M12 3v18"></path>
                        <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"></path>
                      </svg>
                      <div>
                        <h1 class="text-3xl font-semibold text-gray-900">
                          Legal Redlines Summary &amp; Outstanding Issues
                        </h1>
                        <p class="text-lg text-gray-600">
                          Comprehensive legal due diligence analysis for Kaseya
                        </p>
                      </div>
                    </div>
                    <div class="flex items-center gap-6 text-sm">
                      <div class="flex items-center gap-2 text-gray-500">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-calendar w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M8 2v4"></path>
                          <path d="M16 2v4"></path>
                          <rect
                            width="18"
                            height="18"
                            x="3"
                            y="4"
                            rx="2"
                          ></rect>
                          <path d="M3 10h18"></path>
                        </svg>
                        Generated: August 13, 2025
                      </div>
                      <div class="flex items-center gap-2 text-gray-500">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-user w-4 h-4"
                          aria-hidden="true"
                        >
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        Legal Team Review
                      </div>
                      <span
                        data-slot="badge"
                        class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&amp;]:hover:bg-primary/90 bg-sai-blue text-white"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-clock w-3 h-3 mr-1"
                          aria-hidden="true"
                        >
                          <path d="M12 6v6l4 2"></path>
                          <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                        Phase 3: Legal &amp; Financial DD
                      </span>
                    </div>
                  </div>
                  <div class="mb-8">
                    <div class="mb-6">
                      <h2 class="text-xl font-medium mb-2 text-gray-900">
                        Redline Summary by Severity
                      </h2>
                      <div class="flex items-center gap-6 text-sm">
                        <span class="text-gray-600">
                          Total Redlines:
                          <span class="font-semibold">23</span>
                        </span>
                        <span class="text-gray-600">
                          Insured Issues: <span class="font-semibold">8</span>
                        </span>
                      </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                      <div
                        data-slot="card"
                        class="text-card-foreground flex flex-col gap-6 rounded-xl bg-white border-gray-200 border p-6 transition-all duration-200 hover:shadow-lg"
                      >
                        <div class="flex items-center gap-3 mb-4">
                          <div class="p-3 rounded-xl bg-gray-100">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-file-x w-6 h-6 text-red-600 dark:text-red-400"
                              aria-hidden="true"
                            >
                              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                              <path d="m14.5 12.5-5 5"></path>
                              <path d="m9.5 12.5 5 5"></path>
                            </svg>
                          </div>
                          <div>
                            <span
                              data-slot="badge"
                              class="inline-flex items-center justify-center rounded-md w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 border font-medium text-xs px-3 py-1"
                            >
                              HIGH
                            </span>
                            <div class="text-sm font-medium mt-1 text-gray-900">
                              Lawyer Owned
                            </div>
                          </div>
                        </div>
                        <div class="mb-4">
                          <div class="text-3xl font-bold mb-1 text-red-600 dark:text-red-400">
                            4
                          </div>
                          <div class="text-sm text-gray-500">Issues</div>
                        </div>
                        <div class="mb-4">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-2 text-gray-600">
                            Key Examples
                          </h4>
                          <ul class="space-y-1">
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-red-600 dark:text-red-400"></div>
                              <span class="leading-relaxed">
                                Series A w/o consent
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-red-600 dark:text-red-400"></div>
                              <span class="leading-relaxed">
                                Copyleft license in core
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-red-600 dark:text-red-400"></div>
                              <span class="leading-relaxed">
                                IP ownership conflict
                              </span>
                            </li>
                            <li class="text-xs italic text-gray-500">
                              +1 more...
                            </li>
                          </ul>
                        </div>
                        <div class="p-3 rounded-lg bg-gray-50 border-l-2 border-l-gray-300">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-1 text-gray-600">
                            Action Required
                          </h4>
                          <p class="text-xs leading-relaxed text-gray-700">
                            Immediate legal review required
                          </p>
                        </div>
                      </div>
                      <div
                        data-slot="card"
                        class="text-card-foreground flex flex-col gap-6 rounded-xl bg-white border-gray-200 border p-6 transition-all duration-200 hover:shadow-lg"
                      >
                        <div class="flex items-center gap-3 mb-4">
                          <div class="p-3 rounded-xl bg-gray-100">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-handshake w-6 h-6 text-orange-600 dark:text-orange-400"
                              aria-hidden="true"
                            >
                              <path d="m11 17 2 2a1 1 0 1 0 3-3"></path>
                              <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>
                              <path d="m21 3 1 11h-2"></path>
                              <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path>
                              <path d="M3 4h8"></path>
                            </svg>
                          </div>
                          <div>
                            <span
                              data-slot="badge"
                              class="inline-flex items-center justify-center rounded-md w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950 border-orange-200 dark:border-orange-800 border font-medium text-xs px-3 py-1"
                            >
                              MED-HIGH
                            </span>
                            <div class="text-sm font-medium mt-1 text-gray-900">
                              Negotiate
                            </div>
                          </div>
                        </div>
                        <div class="mb-4">
                          <div class="text-3xl font-bold mb-1 text-orange-600 dark:text-orange-400">
                            6
                          </div>
                          <div class="text-sm text-gray-500">Issues</div>
                        </div>
                        <div class="mb-4">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-2 text-gray-600">
                            Key Examples
                          </h4>
                          <ul class="space-y-1">
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-orange-600 dark:text-orange-400"></div>
                              <span class="leading-relaxed">
                                CTO IP assignment missing
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-orange-600 dark:text-orange-400"></div>
                              <span class="leading-relaxed">
                                Advisor equity terms
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-orange-600 dark:text-orange-400"></div>
                              <span class="leading-relaxed">
                                Non-compete duration
                              </span>
                            </li>
                            <li class="text-xs italic text-gray-500">
                              +1 more...
                            </li>
                          </ul>
                        </div>
                        <div class="p-3 rounded-lg bg-gray-50 border-l-2 border-l-gray-300">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-1 text-gray-600">
                            Action Required
                          </h4>
                          <p class="text-xs leading-relaxed text-gray-700">
                            Negotiation or structural changes needed
                          </p>
                        </div>
                      </div>
                      <div
                        data-slot="card"
                        class="text-card-foreground flex flex-col gap-6 rounded-xl bg-white border-gray-200 border p-6 transition-all duration-200 hover:shadow-lg"
                      >
                        <div class="flex items-center gap-3 mb-4">
                          <div class="p-3 rounded-xl bg-gray-100">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-shield-check w-6 h-6 text-yellow-600 dark:text-yellow-400"
                              aria-hidden="true"
                            >
                              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </div>
                          <div>
                            <span
                              data-slot="badge"
                              class="inline-flex items-center justify-center rounded-md w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-800 border font-medium text-xs px-3 py-1"
                            >
                              MEDIUM
                            </span>
                            <div class="text-sm font-medium mt-1 text-gray-900">
                              Insure
                            </div>
                          </div>
                        </div>
                        <div class="mb-4">
                          <div class="text-3xl font-bold mb-1 text-yellow-600 dark:text-yellow-400">
                            8
                          </div>
                          <div class="text-sm text-gray-500">Issues</div>
                        </div>
                        <div class="mb-4">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-2 text-gray-600">
                            Key Examples
                          </h4>
                          <ul class="space-y-1">
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-yellow-600 dark:text-yellow-400"></div>
                              <span class="leading-relaxed">
                                No 409A valuation
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-yellow-600 dark:text-yellow-400"></div>
                              <span class="leading-relaxed">
                                GPL in infrastructure
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-yellow-600 dark:text-yellow-400"></div>
                              <span class="leading-relaxed">
                                Unknown SAFE agreements
                              </span>
                            </li>
                            <li class="text-xs italic text-gray-500">
                              +1 more...
                            </li>
                          </ul>
                        </div>
                        <div class="p-3 rounded-lg bg-gray-50 border-l-2 border-l-gray-300">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-1 text-gray-600">
                            Action Required
                          </h4>
                          <p class="text-xs leading-relaxed text-gray-700">
                            Insurance or contractual protection
                          </p>
                        </div>
                      </div>
                      <div
                        data-slot="card"
                        class="text-card-foreground flex flex-col gap-6 rounded-xl bg-white border-gray-200 border p-6 transition-all duration-200 hover:shadow-lg"
                      >
                        <div class="flex items-center gap-3 mb-4">
                          <div class="p-3 rounded-xl bg-gray-100">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="lucide lucide-eye-off w-6 h-6 text-green-600 dark:text-green-400"
                              aria-hidden="true"
                            >
                              <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"></path>
                              <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"></path>
                              <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"></path>
                              <path d="m2 2 20 20"></path>
                            </svg>
                          </div>
                          <div>
                            <span
                              data-slot="badge"
                              class="inline-flex items-center justify-center rounded-md w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800 border font-medium text-xs px-3 py-1"
                            >
                              LOW
                            </span>
                            <div class="text-sm font-medium mt-1 text-gray-900">
                              Ignore
                            </div>
                          </div>
                        </div>
                        <div class="mb-4">
                          <div class="text-3xl font-bold mb-1 text-green-600 dark:text-green-400">
                            5
                          </div>
                          <div class="text-sm text-gray-500">Issues</div>
                        </div>
                        <div class="mb-4">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-2 text-gray-600">
                            Key Examples
                          </h4>
                          <ul class="space-y-1">
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-green-600 dark:text-green-400"></div>
                              <span class="leading-relaxed">
                                Cap table rounding errors
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-green-600 dark:text-green-400"></div>
                              <span class="leading-relaxed">
                                Seed board observer rights
                              </span>
                            </li>
                            <li class="text-xs flex items-start gap-2 text-gray-700">
                              <div class="w-1 h-1 rounded-full mt-2 flex-shrink-0 bg-green-600 dark:text-green-400"></div>
                              <span class="leading-relaxed">
                                Minor vesting adjustments
                              </span>
                            </li>
                            <li class="text-xs italic text-gray-500">
                              +1 more...
                            </li>
                          </ul>
                        </div>
                        <div class="p-3 rounded-lg bg-gray-50 border-l-2 border-l-gray-300">
                          <h4 class="text-xs font-medium uppercase tracking-wide mb-1 text-gray-600">
                            Action Required
                          </h4>
                          <p class="text-xs leading-relaxed text-gray-700">
                            Monitor but no immediate action
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    data-slot="card"
                    class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 border-l-4 mb-8 bg-white border-gray-200"
                  >
                    <div class="flex items-center gap-3 mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-square-check-big w-6 h-6 text-sai-blue"
                        aria-hidden="true"
                      >
                        <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"></path>
                        <path d="m9 11 3 3L22 4"></path>
                      </svg>
                      <h3 class="text-lg font-medium text-gray-900">
                        Immediate Action Items
                      </h3>
                    </div>
                    <div class="space-y-3">
                      <div class="flex items-start gap-3 p-3 rounded-lg bg-gray-50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-circle-alert w-5 h-5 text-red-500 mt-0.5 flex-shrink-0"
                          aria-hidden="true"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" x2="12" y1="8" y2="12"></line>
                          <line x1="12" x2="12.01" y1="16" y2="16"></line>
                        </svg>
                        <div class="flex-1">
                          <h4 class="font-medium mb-1 text-gray-900">
                            IP Assignment: CTO Dan Tomaszewski never signed
                            comprehensive IP assignment agreement covering
                            pre-incorporation work
                          </h4>
                          <p class="text-sm text-gray-600">
                            Draft retroactive IP assignment agreement with
                            carve-outs for existing commitments
                          </p>
                          <div class="flex items-center gap-4 mt-2 text-xs">
                            <span class="text-gray-500">
                              Assignee: Legal (external)
                            </span>
                            <span
                              data-slot="badge"
                              class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950"
                            >
                              Pending
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="flex items-start gap-3 p-3 rounded-lg bg-gray-50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-circle-alert w-5 h-5 text-red-500 mt-0.5 flex-shrink-0"
                          aria-hidden="true"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" x2="12" y1="8" y2="12"></line>
                          <line x1="12" x2="12.01" y1="16" y2="16"></line>
                        </svg>
                        <div class="flex-1">
                          <h4 class="font-medium mb-1 text-gray-900">
                            Corporate Structure: Series A preferred contains
                            unusual liquidation preference without investor
                            consent for future rounds
                          </h4>
                          <p class="text-sm text-gray-600">
                            Negotiate amendment with Series A investors or
                            structure around limitation
                          </p>
                          <div class="flex items-center gap-4 mt-2 text-xs">
                            <span class="text-gray-500">
                              Assignee: Legal (external)
                            </span>
                            <span
                              data-slot="badge"
                              class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950"
                            >
                              In progress
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="flex items-start gap-3 p-3 rounded-lg bg-gray-50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-circle-alert w-5 h-5 text-red-500 mt-0.5 flex-shrink-0"
                          aria-hidden="true"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" x2="12" y1="8" y2="12"></line>
                          <line x1="12" x2="12.01" y1="16" y2="16"></line>
                        </svg>
                        <div class="flex-1">
                          <h4 class="font-medium mb-1 text-gray-900">
                            Software Licensing: Core VSA platform contains GPL
                            v3 licensed components in database layer
                          </h4>
                          <p class="text-sm text-gray-600">
                            Replace GPL components or implement proper
                            isolation/linking structure
                          </p>
                          <div class="flex items-center gap-4 mt-2 text-xs">
                            <span class="text-gray-500">
                              Assignee: Engineering Lead
                            </span>
                            <span
                              data-slot="badge"
                              class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950"
                            >
                              Pending
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-8">
                    <div
                      data-slot="card"
                      class="text-card-foreground flex flex-col gap-6 rounded-xl border p-6 bg-white border-gray-200"
                    >
                      <div class="mb-6">
                        <h2 class="text-xl font-medium mb-2 text-gray-900">
                          Outstanding Redlines - Full Detail View
                        </h2>
                        <p class="text-sm text-gray-500">
                          Comprehensive breakdown of all identified legal issues
                          requiring attention
                        </p>
                      </div>
                      <div class="overflow-x-auto">
                        <div
                          data-slot="table-container"
                          class="relative w-full overflow-x-auto"
                        >
                          <table
                            data-slot="table"
                            class="w-full caption-bottom text-sm"
                          >
                            <thead
                              data-slot="table-header"
                              class="[&amp;_tr]:border-b"
                            >
                              <tr
                                data-slot="table-row"
                                class="hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors"
                              >
                                <th
                                  data-slot="table-head"
                                  class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px] w-40"
                                >
                                  Category
                                </th>
                                <th
                                  data-slot="table-head"
                                  class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px] min-w-96"
                                >
                                  Description
                                </th>
                                <th
                                  data-slot="table-head"
                                  class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px] w-48"
                                >
                                  Source Docs
                                </th>
                                <th
                                  data-slot="table-head"
                                  class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px] w-28"
                                >
                                  Severity
                                </th>
                                <th
                                  data-slot="table-head"
                                  class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px] w-32"
                                >
                                  Status
                                </th>
                                <th
                                  data-slot="table-head"
                                  class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px] w-40"
                                >
                                  Assignee
                                </th>
                                <th
                                  data-slot="table-head"
                                  class="text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px] min-w-64"
                                >
                                  Recommendation
                                </th>
                              </tr>
                            </thead>
                            <tbody
                              data-slot="table-body"
                              class="[&amp;_tr:last-child]:border-0"
                            >
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <Link to="/drilldown">
                                    <div class="font-medium text-gray-900">
                                      IP Assignment
                                    </div>
                                  </Link>
                                  <Link to="/drilldown">
                                    <div class="text-xs text-gray-500 mt-1">
                                      2/15/2024
                                    </div>
                                  </Link>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <Link to="/drilldown">
                                    <div class="text-sm text-gray-600 leading-relaxed">
                                      CTO Dan Tomaszewski never signed
                                      comprehensive IP assignment agreement
                                      covering pre-incorporation work
                                    </div>
                                  </Link>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <Link to="/drilldown">
                                    <div class="flex items-center gap-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                        aria-hidden="true"
                                      >
                                        <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                      </svg>
                                      <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                        ip_assignments/cto_agreement.pdf
                                      </code>
                                    </div>
                                  </Link>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 border text-xs"
                                  >
                                    HIGH
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-circle-pause w-4 h-4 text-orange-500"
                                      aria-hidden="true"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line
                                        x1="10"
                                        x2="10"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                      <line
                                        x1="14"
                                        x2="14"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950"
                                    >
                                      Pending
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Legal (external)
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Draft retroactive IP assignment agreement
                                    with carve-outs for existing commitments
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    IP Assignment
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/18/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Three early interns (2019-2020) have missing
                                    or incomplete IP assignment documentation
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      intern_docs/agreements_2019_2020.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-800 border text-xs"
                                  >
                                    MEDIUM
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-square-check-big w-4 h-4 text-blue-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"></path>
                                      <path d="m9 11 3 3L22 4"></path>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-950"
                                    >
                                      Acknowledged
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    General Counsel
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Founder confirms minimal contributions,
                                    obtain written confirmations or releases
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Corporate Structure
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/10/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Series A preferred contains unusual
                                    liquidation preference without investor
                                    consent for future rounds
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      series_a/certificate_of_incorporation.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 border text-xs"
                                  >
                                    HIGH
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-clock w-4 h-4 text-yellow-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M12 6v6l4 2"></path>
                                      <circle cx="12" cy="12" r="10"></circle>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950"
                                    >
                                      In progress
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Legal (external)
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Negotiate amendment with Series A investors
                                    or structure around limitation
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Corporate Structure
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/12/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Board composition requires Series A director
                                    approval for certain acquisition decisions
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      series_a/voting_agreement.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950 border-orange-200 dark:border-orange-800 border text-xs"
                                  >
                                    MED-HIGH
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-circle-pause w-4 h-4 text-orange-500"
                                      aria-hidden="true"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line
                                        x1="10"
                                        x2="10"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                      <line
                                        x1="14"
                                        x2="14"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950"
                                    >
                                      Pending
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Deal Team
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Obtain Series A investor consent letter or
                                    negotiate governance changes
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Software Licensing
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/20/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Core VSA platform contains GPL v3 licensed
                                    components in database layer
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      tech_dd/license_audit.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800 border text-xs"
                                  >
                                    HIGH
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-circle-pause w-4 h-4 text-orange-500"
                                      aria-hidden="true"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line
                                        x1="10"
                                        x2="10"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                      <line
                                        x1="14"
                                        x2="14"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950"
                                    >
                                      Pending
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Engineering Lead
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Replace GPL components or implement proper
                                    isolation/linking structure
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Software Licensing
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/22/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Multiple LGPL libraries in infrastructure
                                    stack without proper attribution
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      tech_dd/oss_inventory.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-800 border text-xs"
                                  >
                                    MEDIUM
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-square-check-big w-4 h-4 text-blue-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"></path>
                                      <path d="m9 11 3 3L22 4"></path>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-950"
                                    >
                                      Acknowledged
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Engineering Lead
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Add proper attribution notices and ensure
                                    compliance documentation
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Equity Structure
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/25/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Option pool calculation discrepancies
                                    between 409A and cap table management
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      cap_table/option_pool_analysis.xlsx
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-800 border text-xs"
                                  >
                                    MEDIUM
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-clock w-4 h-4 text-yellow-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M12 6v6l4 2"></path>
                                      <circle cx="12" cy="12" r="10"></circle>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950"
                                    >
                                      In progress
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Finance Team
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Reconcile with 409A provider and update cap
                                    table accordingly
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Equity Structure
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/28/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Two advisors have informal equity
                                    commitments without formal documentation
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      advisors/email_commitments.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950 border-orange-200 dark:border-orange-800 border text-xs"
                                  >
                                    MED-HIGH
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-circle-pause w-4 h-4 text-orange-500"
                                      aria-hidden="true"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line
                                        x1="10"
                                        x2="10"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                      <line
                                        x1="14"
                                        x2="14"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950"
                                    >
                                      Pending
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    General Counsel
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Formalize advisor agreements or obtain
                                    written waivers
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Material Contracts
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    3/1/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Microsoft partnership agreement contains
                                    change of control provisions requiring
                                    consent
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      contracts/microsoft_partnership.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950 border-orange-200 dark:border-orange-800 border text-xs"
                                  >
                                    MED-HIGH
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-circle-pause w-4 h-4 text-orange-500"
                                      aria-hidden="true"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line
                                        x1="10"
                                        x2="10"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                      <line
                                        x1="14"
                                        x2="14"
                                        y1="15"
                                        y2="9"
                                      ></line>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950"
                                    >
                                      Pending
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Business Development
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Engage Microsoft for consent or negotiate
                                    amendment terms
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Material Contracts
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    3/3/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Key customer contracts (&gt;$1M ARR) lack
                                    adequate change of control carve-outs
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      contracts/key_customer_analysis.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-800 border text-xs"
                                  >
                                    MEDIUM
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-clock w-4 h-4 text-yellow-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M12 6v6l4 2"></path>
                                      <circle cx="12" cy="12" r="10"></circle>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950"
                                    >
                                      In progress
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Sales Operations
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Review top 20 customer contracts and assess
                                    consent requirements
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Regulatory Compliance
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/8/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    SOC 2 Type II audit has three open findings
                                    related to access controls
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      compliance/soc2_report_2023.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950 border-yellow-200 dark:border-yellow-800 border text-xs"
                                  >
                                    MEDIUM
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-clock w-4 h-4 text-yellow-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M12 6v6l4 2"></path>
                                      <circle cx="12" cy="12" r="10"></circle>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-950"
                                    >
                                      In progress
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Security Team
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Complete remediation plan and obtain updated
                                    audit opinion
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Regulatory Compliance
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    2/14/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    GDPR data processing agreements need updates
                                    for recent acquisitions
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      compliance/gdpr_dpa_audit.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950 border-orange-200 dark:border-orange-800 border text-xs"
                                  >
                                    MED-HIGH
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-square-check-big w-4 h-4 text-blue-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"></path>
                                      <path d="m9 11 3 3L22 4"></path>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-950"
                                    >
                                      Acknowledged
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Legal (external)
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Update DPAs and ensure proper data mapping
                                    for acquired entities
                                  </div>
                                </td>
                              </tr>
                              <tr
                                data-slot="table-row"
                                class="data-[state=selected]:bg-muted border-b cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                              >
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="font-medium text-gray-900">
                                    Tax &amp; Accounting
                                  </div>
                                  <div class="text-xs text-gray-500 mt-1">
                                    3/5/2024
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    R&amp;D tax credit calculations may be
                                    impacted by acquisition accounting
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-folder-open w-4 h-4 text-gray-400"
                                      aria-hidden="true"
                                    >
                                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2"></path>
                                    </svg>
                                    <code class="text-xs text-gray-600 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
                                      tax/rd_credit_analysis.pdf
                                    </code>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <span
                                    data-slot="badge"
                                    class="inline-flex items-center justify-center rounded-md px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-primary/90 text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-950 border-green-200 dark:border-green-800 border text-xs"
                                  >
                                    LOW
                                  </span>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="flex items-center gap-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-square-check-big w-4 h-4 text-blue-500"
                                      aria-hidden="true"
                                    >
                                      <path d="M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344"></path>
                                      <path d="m9 11 3 3L22 4"></path>
                                    </svg>
                                    <span
                                      data-slot="badge"
                                      class="inline-flex items-center justify-center rounded-md border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&amp;&gt;svg]:size-3 gap-1 [&amp;&gt;svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&amp;]:hover:bg-accent [a&amp;]:hover:text-accent-foreground text-xs text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-950"
                                    >
                                      Acknowledged
                                    </span>
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm font-medium text-gray-900">
                                    Tax Advisor
                                  </div>
                                </td>
                                <td
                                  data-slot="table-cell"
                                  class="p-2 align-middle whitespace-nowrap [&amp;:has([role=checkbox])]:pr-0 [&amp;&gt;[role=checkbox]]:translate-y-[2px]"
                                >
                                  <div class="text-sm text-gray-600 leading-relaxed">
                                    Coordinate with tax counsel on
                                    post-acquisition credit optimization
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Summary;
